// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D16_eOV","breadcrums":"_5D2sMQ0m","network-profile":"_5D3cdW3-","working-with":"_5DCqVv4l","card":"_5D1ijz8P"};